import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'
import getSavedState from '../../utils/get-state'
import store from '../store'

const initialState = {
  currentUser: getSavedState('auth.currentUser'),
  filteredDocItems: [],
  customer: '',
  customerUser: '',
  product: '',
  orderNo: '',
  referenceNo: '',
  firstName: '',
  lastName: '',
  businessName: '',
  ssn: '',
  fromDate: '',
  toDate: '',
  fileType: null,
  status: null,
  pageSize: 15,
  currentPage: 1,
  totalRecordsCount: 1,
}

export const state = { ...initialState }

export const getters = {
  filteredDocItems(state) {
    return state.filteredDocItems
  },
  totalRecordsCount(state) {
    return state.totalRecordsCount
  },
  customer(state) {
    return state.customer
  },
  orderNo(state) {
    return state.orderNo
  },
  rows(state) {
    return state.totalRecordsCount
  },
}

export const mutations = {
  setUserToken(state, token) {
    state.currentUser.access_token = token
  },
  resetState(state) {
    Object.assign(state, initialState)
  },
  setTotalRecords(state, totalRecords) {
    state.totalRecordsCount = totalRecords
  },
  setPageSize(state, pageSize) {
    state.pageSize = pageSize
  },
  setCurrentPage(state, pageNumber) {
    state.currentPage = pageNumber
  },
  setCustomer(state, customerVal) {
    state.customer = customerVal
  },
  setCustomerUser(state, customerUser) {
    state.customerUser = customerUser
  },
  setProduct(state, productId) {
    state.product = productId
  },
  setOrderNo(state, orderNo) {
    state.orderNo = orderNo
  },
  setReferenceNo(state, refNo) {
    state.referenceNo = refNo
  },
  setStatus(state, status) {
    state.status = status
  },
  setFirstName(state, firstName) {
    state.firstName = firstName
  },
  setLastName(state, lastName) {
    state.lastName = lastName
  },
  setBusinessName(state, businessName) {
    state.businessName = businessName
  },
  setDocFrom(state, docFrom) {
    state.docFrom = docFrom
  },
  setDocTo(state, docTo) {
    state.docTo = docTo
  },
  setSsn(state, ssn) {
    state.ssn = ssn
  },
  setFileType(state, fileType) {
    state.fileType = fileType
  },
  setFromDate: (state, fromDate) => {
    state.fromDate = fromDate
  },
  setToDate: (state, toDate) => {
    state.toDate = toDate
  },
  setDocTable(state, documentsData) {
    state.filteredDocItems = documentsData.map((document) => {
      var ssn = document.ssn
      return {
        documentName: document.fileName,
        documentDate: document.createdDateTime
          .toString('MM/dd/yyyy hh:mm')
          .replace('T', ' '),
        filePath: document.filePath,
        orderNo: document.orderId,
        reference: document.referenceNumber,
        ssnDoc: ssn
          ? ssn.length > 4
            ? ssn
                .replace(/\D/g, '')
                .substring(0, ssn.length - 4)
                .replace(/^(\d{3})/, '$1-')
                .replace(/-(\d{2})/, '-$1-')
                .replace(/(\d)-(\d{4}).*/, '$1-$2')
                .replace(/\w/g, '*') + ssn.substring(ssn.length - 4)
            : ''
          : '',
        firstName: document.firstName,
        lastName: document.lastName,
        customerName: document.customerName,
        orderedBy: document.orderedBy,
        orderedFor: document.orderedFor,
        productInfo: document.product,
        productId: document.productId,
        status: document.status,
      }
    })
  },
}

export const actions = {
  addForUrl(key, value) {
    return value || value === 0 ? `&${key}=${value}` : ''
  },
  fetchDocumentsData(
    { state, commit },
    {
      customerId,
      pageNumber,
      pageSize,
      customerName,
      orderNo,
      referenceNumber,
      firstName,
      lastName,
      status,
      fromDate,
      toDate,
      ssn,
      productId,
      fileType,
    }
  ) {
    var url = ''
    url =
      appConfig.apiEndPoint +
      endpoint.reportApiPath.getDocumentsData +
      '?CustomerId=' +
      customerId +
      actions.addForUrl('CustomerName', customerName) +
      actions.addForUrl('PageSize', pageSize) +
      actions.addForUrl('PageNumber', pageNumber) +
      actions.addForUrl('OrderId', orderNo) +
      actions.addForUrl('ProductId', productId) +
      actions.addForUrl('ReferenceNumber', referenceNumber) +
      actions.addForUrl('SSN', ssn) +
      actions.addForUrl('FirstName', firstName) +
      actions.addForUrl('LastName', lastName) +
      actions.addForUrl('Status', status) +
      actions.addForUrl('FromDate', fromDate) +
      actions.addForUrl('ToDate', toDate) +
      actions.addForUrl('FileTypeId', fileType)
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        if (response.data) {
          commit('setTotalRecords', response.data.totalRecordsCount)
          commit('setDocTable', response.data.managementDocument)
          return state.filteredDocItems
        }
      })
      .catch((err) => {
        err && commit('setDocTable', [])
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
